<template>
  <div class="m-content" >
		<HeaderBox/>
    <div class="report-content">
        <div class="report-area">
          <p ><b></b>
          你好，非常高兴你能参加本次生涯周活动。整体来说，你在生涯决策方面存在
          <span v-if="cddqResult.baiCddqScore>75" class="warn1">比较严重的困难</span>
          <span v-if="cddqResult.baiCddqScore<=75 && cddqResult.baiCddqScore>=37.5" class="warn2">一般困难</span>
          <span v-if="cddqResult.baiCddqScore<37.5" class="warn3">很少困难</span>
          </p>
          <p>困难的得分为：
            <span v-if="cddqResult.baiCddqScore>75" class="warn1">{{cddqResult.baiCddqScore}}</span>
            <span v-if="cddqResult.baiCddqScore<=75 && cddqResult.baiCddqScore>=37.5" class="warn2">{{cddqResult.baiCddqScore}}</span>
            <span v-if="cddqResult.baiCddqScore<37.5" class="warn3">{{cddqResult.baiCddqScore}}</span>
            。分数越高代表困难程度越高，以下是十项更加细化的困难得分。
          </p>
          <div align="center">
            <img class="report-img" :src="cddqResult.cddqReportImageUrl"/>
          </div>
        </div>
        <div class="report-area">
          <h2 class="type-title">十类生涯决策困难说明</h2>
          <p>1. 缺乏动机：个体认为自己缺乏做出一个聪明决策的信息，尤其是缺少关于如何做一个职业决策的信息。例如，个体可能不知道都该考虑哪些因素，或在整合关于自己的信息（例如，自己的优势和劣势）和不同职位方面有困难（例如，一个具体的职位需要什么样的能力）。</p>
          <p>2. 犹豫不决人格：在做决定上存在着普遍的困难。许多人在他们日常生活的方方面面都倾向于犹豫不决。决定常常伴随着对失败和承诺的恐惧及退缩。因此，这一类的人当他们面临做决定的状况时，可能会拖延或不断地改变主意。有时候，他们可能感到需要他人来肯定他们的决定，这样才能使他们感到自己做了一个正确的决定。</p>
          <p>3. 不合理信念：对职业决策过程有着扭曲的感受和想法。例如相信人只能选择一次职业，这一次就必须是一生的承诺，或人必须对一个职位付出所有的激情。这样的想法都可能会妨碍职业决定的过程。</p>
          <p>4. 缺乏决策过程的信息：个体认为自己缺乏做出一个聪明决策的信息，尤其是缺少关于如何做一个职业决策的信息。例如，个体可能不知道都该考虑哪些因素，或在整合关于自己的信息（例如，自己的优势和劣势）和不同职位方面有困难（例如，一个具体的职位需要什么样的能力）。</p>
          <p>5. 缺乏关于自己的信息：个体感到缺乏关于自己的信息。个体可能并不知道他想要的是什么——例如，他喜欢什么样的工作状态或在决策过程中他应该考虑什么因素。高分也可能意味着缺乏关于能力和技能的信息——例如，个体不知道在某个领域里他是否有足够的能力，或他是否具有对于某个职业来说相当关键的人格特质。</p>
          <p>6. 缺乏关于职业的信息：缺乏对现有的职业选择的了解：都有什么样的选择以及/或每个选择都有什么特征。</p>
          <p>7. 缺乏获得信息的方式：缺乏获得附加信息或协助的信息的方式。例如，个体可能不知道到哪里去寻找关于职位的信息，或到哪里进行个体的职业咨询。</p>
          <p>8. 不可靠的信息：个体感到关于自己的信息或所考虑的职业方面的信息之间包含着冲突。例如，在自己看自己和别人看待他之间存在着冲突，或者在关于自己的主观信息和客观信息之间存在冲突（例如，一个人的艺术老师告诉他，他的画很出色，但他却认为他的画很平庸）。</p>
          <p>9. 内部冲突：内部的困惑感。这种困惑可能来自于个体价值观的冲突（例如，个体收到了一个不错的工作录用单，但自己的恋人却在另一个城市）。内部冲突也可以发生在一个吸引人的工作中包含了一个令你不喜欢的因素（例如，个体想当一个医生，但它需要相当长时间的训练），或者当好几个工作看起来都同样吸引人。</p>
          <p>10. 外部冲突：个体的偏好和重要他人的偏好之间存在着鸿沟，或者两个重要他人的意见存在着冲突。外部冲突发生在当个体做出了一个职业决定而它的重要他人则更喜欢另一个的时候。例如，一个人可能希望少上点学，而他的父母则希望他能够读博士。</p>
        </div>
        <div class="report-area">
          <h2>基于测评结果的建议</h2>
        </div>
        <div class="report-area">
          <h3>一、基于测评，你面临严重困难的维度：<span v-if="listLength(cddqResult.listDifficultHigh)">无</span></h3>
        </div>
        <div class="report-area" v-for="(item,index) in cddqResult.listDifficultHigh">
          <div align="center">
            <h4>{{item.cddq.dimensionName}}</h4>
          </div>
          <div v-html="item.cddq.solution"></div>
        </div>
        <div class="report-area">
          <h3>二、基于测评，你面临中等困难的维度：<span v-if="listLength(cddqResult.listDifficultMiddle)">无</span></h3>
        </div>
        <div class="report-area" v-for="(item,index) in cddqResult.listDifficultMiddle">
          <div align="center">
            <h4>{{item.cddq.dimensionName}}</h4>
          </div>
          <div v-html="item.cddq.solution"></div>
        </div>
    </div>
		<FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'mineReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      cddqResult:''
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-生涯扫雷')
    this.getReport()
  },
  methods:{
    listLength(list){
      let status = true;
      if(list&&list.length>0){
        status = false;
      }
      return status
    },
    compareScore(score,standard){
      let status = false;
      if(standard==1&&score>=75){
        status=true
      }else if(standard==3&&score<37.5){
        status=true
      }else if(standard==2&&37.5<=score&&score<75){
        status=true
      }
      return status
    },
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosCddqReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data;
            if(Result){
              this.cddqResult=Result.cddqResult
              // 弹幕
              let level = '一般困难'
              if(this.cddqResult.baiCddqScore<37.5){
                level = '很少困难'
              }else if(this.cddqResult.baiCddqScore>75){
                level = '比较严重的困难'
              }
              this.cddqResult.listDifficultMiddle.sort((a,b)=>{return a.fAvg-b.fAvg})
              let text=''
              if(this.cddqResult.listDifficultMiddle[0].fAvg<3){
                text = '的生涯决策困难得分居然只有'+this.cddqResult.listDifficultMiddle[0].fAvg+'分'
              }else{
                let num = Math.round(Math.random()),length = this.cddqResult.listDifficultMiddle.length
                text = '在生涯决策上存在'+level
                if(num){
                  text = '最大的困难是'+this.cddqResult.listDifficultMiddle[length-1].dimensionName
                }
              }
              if(text){
                store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
              }
            }
          }
        })
        .catch((error)=>{
          console.error(error);
        })
    }
  }
}
</script>
<style scoped>
  .warn1,.warn2,.warn3{
    color:#000000;
    font-size:14px;
    font-weight:bold;
  }
  .warn1{
    background-color:#FF0505;
  }
  .warn2{
    background-color:#FFFF05;
  }
  .warn3{
    background-color:#05BC57;
  }
  .report-area h2{
    color: #404040;
    font-size: 0.44rem;
    margin: 0 0 .1rem;
    text-align:center;
    font-weight:bold;
  }
  .report-area h3{
    color: #404040;
    font-size: 0.36rem;
    margin: 0 0 .1rem;
    font-weight:bold;
  }
  .report-area h4 {
    color: #404040;
    font-size: 0.32rem;
    font-weight: bold;
    margin:0.1rem 0 0;
  }
</style>
